import { render, staticRenderFns } from "./marketingSocialListShow.vue?vue&type=template&id=565b2c9e&scoped=true&"
import script from "./marketingSocialListShow.vue?vue&type=script&lang=js&"
export * from "./marketingSocialListShow.vue?vue&type=script&lang=js&"
import style0 from "./marketingSocialListShow.vue?vue&type=style&index=0&id=565b2c9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565b2c9e",
  null
  
)

export default component.exports